module.exports = __webpack_public_path__ + "img/map-location.f4e74871.svg";